<template>
  <dropdown
    v-if="itemRefNumber && items.length > 0"
    title="Go To..."
    class="breadcrumb-item-picker with-picker"
  >
    <div class="label">
      <span>#{{itemRefNumber}}<span v-if="showItemTitle && $screen.isMobile($mq)" class="fade-in">:&nbsp;{{itemTitle}}</span></span>
      <i class="ddi ddi-caret-down" />
    </div>
    <template #content>
      <div>
        <ul>
          <li 
            v-for="item in items"
            :key="item.itemID"
            @click="$emit('navigate', item)"
          >
            <span :class="{'selected': itemRefNumber === item.refNumber}">
              #{{ item.refNumber }}: {{ item.title }}
            </span>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
  <div v-else-if="itemRefNumber" class="breadcrumb-item-picker">
    <div class="label">
      <span>#{{itemRefNumber}}<span v-if="showItemTitle && $screen.isMobile($mq)" class="fade-in">:&nbsp;{{itemTitle}}</span></span>
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'

/* API */

export default defineComponent({
  name: 'BreadcrumbItemPicker',
  props: {
    itemRefNumber: {
      type: Number,
      default: null,
    },
    itemTitle: {
      type: String,
      default: '',
    },
    showItemTitle: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array as () => IBreadcrumbItemMenuItem[],
      default: (): IBreadcrumbItemMenuItem[] => [],
    },
  },
  emits: ['navigate'],
})
</script>

<style lang="scss">
.breadcrumb-item-picker {
  @include single-line-ellipsis;
  max-width: 100%;

  &.with-picker:hover {
    .label span {
      border-bottom: $border--solid-medium;
    }
  }

  .label {
    @include single-line-ellipsis;
    color: var(--color-text-secondary);

    .ddi-caret-down {
      margin-left: 6px;
      font-size: 10px;
      top: -1px;
    }

    .fade-in {
      animation-name: dd-fade-in;
      animation-duration: 0.4s;
    }
  }
}
</style>
